import "./style.css";
import React, { useState, useEffect } from "react";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import loadConfig from "../../Services/Api/ApiServices";

export default function TextAreaAHSF(props) {
  const [dataJsonObject, SetDataJsonObject] = useState();
  const JsonDataa = useSelector((state) => state.FetchDataJson);
  const [inputValue, setInputValue] = useState(
    props.value == undefined || props.value == ""
      ? props.defaultValue
      : props.value || ""
  );
  //[,]
  //this function to get data from main.json file by fieldsName props
  const [arabicError, setArabicError] = useState(false);
  const [englishError, setEnglishError] = useState(false);
  const lang = useSelector((state) => state.languageReducer.Language);


    useEffect(() => {
      if (props.value === "" || props.value === null) {
        setInputValue("");
      }
    }, [props.value]);

  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    let fieldsName = props.fieldsName;
    let code = jsonData[fieldsName];
    SetDataJsonObject(code);
  };

  useEffect(() => {
    dataJson();
  }, []);

  const handleChange = (e) => {
    let fieldsName = props.fieldsName;
    let code = JsonDataa?.JsonData[props.fieldsName];

    let wordsNumber = code.wordsNumber ? code.wordsNumber : 2000;
    console.log(wordsNumber, "code");

    const value = e.target.value;
    let wordsArray = value.trim().split(/\s+/);

    console.log(wordsArray, "lengh");

    if (wordsArray.length <= wordsNumber) {
      setInputValue(value);
      console.log(value, "hgfgfg");
      ////////////////////////////////////////////////////////
      if (wordsArray.length <= wordsNumber) {
        if (props.type === "arabic") {
          const arabicRegex =
            /^[\u0600-\u06FF\u0660-\u0669 0-9\s.,!?;:'"-()،؟]*$/;

          if (!arabicRegex.test(value)) {
            setArabicError(true);
          } else {
            setArabicError(false);
          }

          setInputValue(value);
          if (props.onChange)
            props.onChange({ ...e, target: { ...e.target, value } });
          return;
        }

        if (props.type === "english") {
          const englishRegex = /^[A-Za-z0-9\s.,!?;:'"-()]*$/;

          if (!englishRegex.test(value)) {
            setEnglishError(true);
          } else {
            setEnglishError(false);
          }

          setInputValue(value);
          if (props.onChange)
            props.onChange({
              ...e,
              target: { ...e.target, value },
            });
          return;
        }
      }

      setInputValue(value);
      if (props.onChange) props.onChange(e);
    }
    // else {
    //   let number = wordsArray.slice(0, wordsNumber);
    //   if (fieldsName == "BI_Activity" || fieldsName == "BI_ItemName") {
    //     setInputValue(number);
    //     // console.log(number, "dffdf",wordsNumber);
    //   } else {
    //     setInputValue(number.join(" "));
    //     // console.log(number.join(" "), "dffdf",wordsNumber);
    //   }

    //   if (props.onChange) {
    //     props.onChange(e);
    //   }
    // }
    // props.onChange
  };

  return dataJsonObject ? (
    <>
      {props.show && (
        <div className="containerInputAHSF">
          <div className="label-container">
            <label
              className="labelInput"
              htmlFor={dataJsonObject.code}
              title={
                props.lang == "ar"
                  ? dataJsonObject.nameEN
                  : dataJsonObject.nameAR
              }
              style={{ textAlign: lang === "ar" ? "right" : "left" }}
            >
              {props.lang !== "en"
                ? dataJsonObject.nameAR
                : dataJsonObject.nameEN}
              {dataJsonObject.isRequired ? <span>*</span> : ""}
            </label>
            {props.showValidationMessage && (
              <span
                className="validation-icon"
                data-tooltip={props.validationMessage}
              >
                <FontAwesomeIcon icon={faCircleExclamation} />
                &nbsp;
              </span>
            )}
          </div>
          <textarea
            id={dataJsonObject.code}
            // value={inputValue ? inputValue : props.value}
            value={inputValue}
            defaultValue={props.defaultValue}
            placeholder={
              props.lang == "ar"
                ? dataJsonObject.PlaceHolderAr
                : dataJsonObject.PlaceHolderEn
            }
            onChange={(e) => {
              handleChange(e);
            }}
            onKeyDown={(e) => {
              if (props.type === "arabic") {
                // const arabicKey = /^[\u0600-\u06FF\s]$/;
                // For Number
                const arabicKey =
                  /^[\u0600-\u06FF\u0660-\u0669 0-9\s.,!?;:'"\-()،؟]+$/;
                if (
                  e.key.length === 1 && // filter only character keys
                  !arabicKey.test(e.key)
                ) {
                  e.preventDefault(); // block invalid key
                  setArabicError(true);
                }
              }
              if (props.type === "english") {
                // const englishKey = /^[A-Za-z\s]$/;
                //For Number
                const englishKey = /^[A-Za-z0-9\s.,!?;:'"\-()]+$/;
                if (e.key.length === 1 && !englishKey.test(e.key)) {
                  e.preventDefault();
                  setEnglishError(true);
                }
              }
            }}
            disabled={props.disabled}
            required={props.required}
            className={props.showValidationMessage ? "textarea-error" : ""}
            onBlur={props.onBlur}
            dir={props.dir}
          />
          {arabicError && (
            <p className="error-message">
              {lang == "ar"
                ? "يمكنك الكتابة باللغة العربية فقط"
                : "You can only write in Arabic"}
            </p>
          )}
          {englishError && (
            <p className="error-message">
              {lang == "ar"
                ? "يمكنك الكتابة باللغة الانجليزية فقط"
                : "You can only write in English"}
            </p>
          )}
          {/* {props.showValidationMessage && (
            <p className="error-message">{props.validationMessage}</p>
          )} */}
        </div>
      )}
    </>
  ) : (
    ""
  );
}
